import './categories-thumbs.scss';

$('.categories-thumbs').each(function () {
	let $this = $(this);

	$this.find('.categories-thumbs__toggle-show-all').on('click', function () {
		let $toggle = $(this);

		if ($this.hasClass('categories-thumbs_show-all')) {
			$this.removeClass('categories-thumbs_show-all');
			$toggle.text('Показать ещё...');
		} else {
			$this.addClass('categories-thumbs_show-all');
			$toggle.text('Свернуть...');
		}
	});
});